module.exports = __webpack_public_path__ + "static/media/DuplicateSlab.40e6b53e.woff2";